export default __webpack_public_path__ + "static/media/Skin Tightening Kit.5555ded7.jpg";